export const Footer = () => {
  return (
    <footer className="footer footer-center p-4 bg-base-300 text-base-content">
      <aside>
        <p className="text-center">
          Copyright © 2024 - All right reserved by AUX LLC.
        </p>
      </aside>
    </footer>
  );
};
